export type ErrorResponseTypes =
  | AdviseErrorResponse
  | TimeoutErrorResponse
  | PayloadTooLargeErrorResponse
  | UnknownErrorResponse;

export enum ErrorResponseType {
  ADVISE = "ADVISE",
  TIMEOUT = "TIMEOUT",
  PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
  UNKNOWN = "UNKNOWN",
}

export interface AdviseErrorResponse {
  type: ErrorResponseType.ADVISE;
  data: AdviseErrorResponseData;
}

export interface TimeoutErrorResponse {
  type: ErrorResponseType.TIMEOUT;
}

export interface PayloadTooLargeErrorResponse {
  type: ErrorResponseType.PAYLOAD_TOO_LARGE;
}

export interface UnknownErrorResponse {
  type: ErrorResponseType.UNKNOWN;
}

export interface AdviseErrorResponseData {
  type: string;
  title: string;
  status: number;
  instance: string;
  advise: Advise;
}

export interface Advise {
  type: AdviseType;
  timestamp: string;
  uuid?: string | null;
  /** @deprecated - only used as fallback */
  message?: string | null;
  messages?: Record<string, string> | null; // language key -> translated message
  validationViolations?: Record<string, string[]> | null;
}

export enum AdviseType {
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
  DATA_ERROR = "DATA_ERROR",
  VALIDATION = "VALIDATION",
}
